// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".delayed-loader[data-v-e43645ce]{font-size:16px;height:16px;width:16px}", ""]);
// Exports
module.exports = exports;
